export default __webpack_public_path__ + "static/media/orc.d8251b62.png";